module.exports = __webpack_public_path__ + "img/top1_edited.c8f998d7.svg";